module.exports = __webpack_public_path__ + "img/ug432.afc3bc0f.png";